"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseOptionData = exports.ActionSpinSound = void 0;
var ActionSpinSound;
(function (ActionSpinSound) {
    ActionSpinSound[ActionSpinSound["WIN"] = 0] = "WIN";
    ActionSpinSound[ActionSpinSound["BIG_WIN"] = 1] = "BIG_WIN";
})(ActionSpinSound = exports.ActionSpinSound || (exports.ActionSpinSound = {}));
function parseOptionData(value) {
    let options;
    if (typeof value === 'function') {
        options = value();
    }
    else {
        options = value || [];
    }
    return options;
}
exports.parseOptionData = parseOptionData;
//# sourceMappingURL=ASInterfaces.js.map